var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.5C4.92188 6.5 2.25 9.21875 2.25 12.5C2.25 13.1562 1.73438 13.625 1.125 13.625C0.46875 13.625 0 13.1562 0 12.5C0 7.95312 3.65625 4.25 8.25 4.25H14.9531V1.625C14.9531 1.20312 15.1875 0.78125 15.6094 0.59375C16.0312 0.453125 16.5469 0.546875 16.875 0.875L20.625 4.625C21.0469 5.04688 21.0469 5.75 20.625 6.17188L16.875 9.92188C16.5469 10.25 16.0312 10.3438 15.6094 10.2031C15.1875 10.0156 14.9531 9.59375 14.9531 9.125V6.5H8.25ZM22.875 11.375C23.4844 11.375 24 11.8906 24 12.5C24 17.0938 20.2969 20.75 15.75 20.75H9V23.375C9 23.8438 8.71875 24.2656 8.29688 24.4531C7.875 24.5938 7.35938 24.5 7.07812 24.1719L3.28125 20.4219C2.85938 20 2.85938 19.2969 3.28125 18.8281L7.07812 15.0781C7.35938 14.7969 7.875 14.7031 8.29688 14.8438C8.71875 15.0312 9 15.4531 9 15.875V18.5H15.75C19.0312 18.5 21.75 15.8281 21.75 12.5C21.75 11.8906 22.2188 11.375 22.875 11.375Z",
    fill: "#BE0042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.344f922015c75c034b609799144e2f8d.svg";
export { ForwardRef as ReactComponent };